import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { SearchModule } from '../search/search.module';
import { AppModalModule } from '../modal/modal.module';
import { ScrollModule } from '../scroll/scroll.module';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';
import { FormModule } from '../form/form.module';
import { ColumnBuilderModalComponent } from './column-builder-modal/column-builder-modal.component';
import { ColumnBuilderComponent } from './column-builder/column-builder.component';
import { ColumnsUpdateWarningModalComponent } from './columns-update-warning-modal/columns-update-warning-modal.component';


@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    SearchModule,
    AppModalModule,
    ScrollModule,
    IconModule,
    ButtonModule,
    FormModule,
  ],
  declarations: [
    ColumnBuilderModalComponent,
    ColumnBuilderComponent,
    ColumnsUpdateWarningModalComponent,
  ],
  exports: [
    ColumnBuilderModalComponent,
    ColumnBuilderComponent,
    ColumnsUpdateWarningModalComponent,
   ],
  providers: []
})
export class ColumnBuilderModule {}
